import React from "react";
import { Container, Col, Row } from "react-bootstrap";

const Sync = () => {
  return (
    <div id="main">
      <Container>
        <Row>
          <Col >hiiihufiehkfejkfuhjhkugiuguggjgdfghkl;xcvbnhukhhikbestrfyguiopuutyetio</Col>
        </Row>
      </Container>
    </div>
  );
};

export default Sync;